import { Mapper } from '../../../../../base/utils/mapper';
import { HeadquartersModel } from '../../../../../domain/models/configuration/company/headquarters.model';
import { HeadquartersEntity } from '../../entities/company/headquarters.entity';


export class HeadquartersImplementationRepositoryMapper extends Mapper<
  HeadquartersEntity,
  HeadquartersModel
> {
  mapFrom(param: HeadquartersEntity): HeadquartersModel {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
  mapTo(param: HeadquartersModel): HeadquartersEntity {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
}
